import { useContext } from "react";
import BlockchainContext from "../store/BlockchainContext";
import { numberWithCommas } from "../utils/util";
import { walletAddressSlicer } from "../utils/util";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import DepositModalContext from "../store/DepositModalContext";

const HeaderSection = () => {
  const { handleConnectToWallet, account, walletBalance, usdPrice } =
    useContext(BlockchainContext);
  const { open, close } = useWeb3Modal();
  const { showModalDis } = useContext(DepositModalContext);

  return (
    <>
      <header>
        <div className="container">
          <div className="col-md-12 col-12 text-center">
            <img
              className="img-fluid"
              src="/images/logo.png"
              alt="MATIC Finance"
            />
          </div>
        </div>
      </header>

      <section id="get_links">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 text-center social_icons">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://t.me/+5fgAVmWNPzY5NmE0"
              >
                <img src="/images/telegram.png" alt="" />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://twitter.com/CapitalMatic"
              >
                <img src="/images/twitter.png" alt="" />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.youtube.com/@maticcapital/featured"
              >
                <img src="/images/youtube.png" alt="" />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.binance.com"
              >
                <img src="/images/binance.png" alt="" />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.trbinance.com"
              >
                <img src="/images/binancetr.png" alt="" />
              </a>
            </div>
            <div className="col-md-12 text-center">
              {account ? (
                <button
                  className="btn btn-light connect_btn connected"
                  // onClick={() => open()}
                  onClick={() => showModalDis()}
                >
                  <div className="row">
                    <div className="img_box">
                      <img
                        className="mr-3"
                        src="/images/login.png"
                        alt="Login"
                      />
                    </div>
                    <div className="desc_box">
                      <span className="mt-1 mb-3">
                        {walletAddressSlicer(account)}
                      </span>
                      <p className="text-dark mb-1">
                        {numberWithCommas(walletBalance, 5)} MATIC
                      </p>
                      <hr />
                      <small className="text-dark">
                        ~ ${numberWithCommas(walletBalance * usdPrice, 2)}
                      </small>
                    </div>
                  </div>
                </button>
              ) : (
                // <div className="connect_btn">
                //   <Web3Button
                //     icon="hide"
                //     label="Connect Wallet"
                //     balance="hide"
                //   />
                // </div>

                <button
                  className="btn btn-light connect_btn"
                  onClick={() => handleConnectToWallet()}
                >
                  <img src="/images/login.png" alt="Login" /> Connect Wallet
                </button>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeaderSection;
